import { Outlet } from "react-router-dom";
import { LayoutDashboard, UserPlus, Network, BarChart3, Building2, Users } from "lucide-react";
import PortalLayout from "@/components/PortalLayout";
import { useAuth } from "@/contexts/AuthContext";
import { STAFF_ADMIN_ROLE, staffCan, staffRoleLabel } from "@/constants/roles";

// `privilege` items show only to staff holding it (Platform Admins hold
// all); `adminOnly` items only to Platform Admins. The API enforces the
// real gate.
const NAV = [
  { title: null, items: [{ label: "Dashboard", path: "/staff", end: true, icon: LayoutDashboard, testId: "dashboard" }] },
  {
    title: "Onboarding",
    items: [
      { label: "Onboarding Queue", path: "/staff/onboarding", icon: UserPlus, testId: "onboarding", privilege: "onboarding" },
      { label: "Vendor Leads", path: "/staff/vendor-leads", icon: Building2, testId: "vendor-leads", privilege: "vendor_leads" },
    ],
  },
  { title: "Network", items: [{ label: "Directories", path: "/staff/directories", icon: Network, testId: "directories", privilege: "directories" }] },
  { title: "Monitoring", items: [{ label: "Transaction Monitor", path: "/staff/transactions", icon: BarChart3, testId: "transactions", privilege: "transactions" }] },
  { title: "Platform", items: [{ label: "Staff Team", path: "/staff/team", icon: Users, testId: "staff-team", adminOnly: true }] },
];

function navFor(user) {
  return NAV.map((section) => ({
    ...section,
    items: section.items.filter((item) => {
      if (item.adminOnly) return user?.role === STAFF_ADMIN_ROLE;
      if (item.privilege) return staffCan(user, item.privilege);
      return true;
    }),
  })).filter((section) => section.items.length > 0);
}

export default function StaffLayout() {
  const { user } = useAuth();
  return (
    <PortalLayout portalLabel="Platform Admin" tenantName="ScapeSource" tenantSubtitle={staffRoleLabel(user?.role)} navSections={navFor(user)} showNotifications={false}>
      <Outlet />
    </PortalLayout>
  );
}
